import React from 'react'
import { Field, getFormValues, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import {
  formContainer,
  titleContainer,
  secondaryTitle,
  buttonContainer
} from './styles/RecoverMyPasswordForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'
import Spinner from '../shared/Spinner'

import * as validators from '../../utils/validators'
import { connect } from 'react-redux'
import { resetPassword } from '../../store/passwordRecovery/actions'

const RecoverMyPasswordForm = ({
  handleSubmit,
  onSubmit,
  isSubmitting,
  isSuccess,
  token,
  translation,
  lang
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmatioPT : validators.passwordConfirmatioES

  return (
    <>
      <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
        <header className={titleContainer}>
          <h2 className={secondaryTitle}>{translation('recoverPasswordForm')['passwordFormTitle']}</h2>
        </header>

        <div>
          <div>
            <Field
              name='password'
              placeholder={translation('recoverPasswordForm')['newPasswordPlaceholder']}
              type='password'
              block
              validate={[required, passwordLength]}
              component={Input}
            />
          </div>

          <div>
            <Field
              name='passwordConfirmation'
              placeholder={translation('recoverPasswordForm')['confirmPasswordPlaceholder']}
              type='password'
              block
              validate={[required, passwordConfirmation]}
              component={Input}
            />
          </div>
        </div>

        <div className={buttonContainer}>
          <Button
            type='submit'
            disabled={isSubmitting}
          >
            {isSubmitting && <Spinner size='0.8rem' />}
            {translation('recoverPasswordForm')['changeButton']}
          </Button>
        </div>
      </form >
    </>
  )
}

RecoverMyPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  translation: PropTypes.func,
  lang: PropTypes.string,
  token: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSuccess: PropTypes.bool
}

const mapStateToProps = (state) => {
  const isSubmitting = state.passwordRecovery.isSubmitting
  const isSuccess = state.passwordRecovery.isSuccess
  const valuesForm = getFormValues('recoverPassword')(state)
  return {
    isSubmitting,
    isSuccess,
    valuesForm
  }
}
const mappedConnect = connect(mapStateToProps)

const mappedReduxForm = reduxForm({
  form: 'recoverPassword',
  onSubmit: async (values, dispatch, props) => {
    dispatch(resetPassword({
      data: values,
      translation: props.translation,
      lang: props.lang,
      token: props.token,
      history: props.history
    }))
  }
})

export default mappedConnect(mappedReduxForm(RecoverMyPasswordForm))
